import React from 'react'

const Behind = () => {
    return (
        <div className='container'>
         <h1>Compiling a C program:- Behind the Scenes</h1>
         <p>C is a mid-level language and it needs a compiler to convert it into an executable code so that the program can be run on our machine. </p> <br />
         <h4><strong>What goes inside the compilation process?</strong></h4>  
         <p>Compiler converts a C program into an executable. There are four phases for a C program to become an executable: </p><br />
         <ol>
             <li>Pre-processing</li>
             <li>Compilation</li>
             <li>Assembly</li>
             <li>Linking</li>
         </ol>
<p>By executing below command, We get the all intermediate files in the current directory along with the executable.</p> <br />
<div className='output'> $gcc –Wall –save-temps filename.c –o filename </div>
 <h3>Pre-processing</h3>
   <p>This is the first phase through which source code is passed. This phase include:  </p> <br />
   <ol>
       <li>Removal of Comments</li>
       <li>Expansion of Macros</li>
       <li>Expansion of the included files.</li>
       <li>Conditional compilation</li>
   </ol>
   <p>The preprocessed output is stored in the filename.i. Let’s see what’s inside <b> filename.i</b>: using <b>$vi filename.i</b>  </p>
   <h3>Analysis: </h3>
      <ol>
          <li>printf contains now a + b rather than add(a, b) that’s because macros have expanded.
Comments are stripped off.</li>
<li>
#include &lt; stdio.h&gt; is missing instead we see lots of code. So header files has been expanded and included in our source file.
</li>
      </ol>
      <h3>Compiling</h3>
      <p>The next step is to compile <b> filename.i</b> and produce an; intermediate compiled output file <b> filename.s.</b> This file is in assembly level instructions. Let’s see through this file using <b>$vi filename.s</b>  </p><br />
<h3>Assembly</h3>
In this phase the filename.s is taken as input and turned into <b> filename.o</b> by assembler. This file contain machine level instructions. At this phase, only existing code is converted into machine language, the function calls like printf() are not resolved. Let’s view this file using <b> $vi filename.o </b> <br />
<h3>Linking</h3>
This is the final phase in which all the linking of function calls with their definitions are done.
 Linker knows where all these functions are implemented. Linker does some extra work also, it adds some 
 extra code to our program which is required when the program starts and ends. For example, there is a code
  which is required for setting up the environment like passing command line arguments. This task can be 
  easily verified by using <b>$size filename.o </b>and  <b>$size filename.</b> Through these commands, we know that how 
  output file increases from an object file to an executable file. This is because of the extra code that
   linker adds with our program. <br />
   <p style={{marginBottom:30}}><b> Note</b> that GCC by default does dynamic linking, so printf() is dynamically linked in above program.</p>
        </div>
    )
}

export default Behind
